import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchModel } from "#modules/models/infra/fetchModel.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const modelQuery = () => ({
  queryKey: queryKeys.models.mine,
  queryFn: () => fetchModel(),
  staleTime: STALE_TIME,
});
